// extracted by mini-css-extract-plugin
export default {"title":"MyInvestment_title__XLvzq"};